import React from 'react';
import { Button } from 'antd';
import { texts } from '../../../../../constants/texts';
import styles from '../AddTenantModal.module.scss';

const ModalFooter = ({
  initialValues,
  addConfirmLoading,
  deleteConfirmLoading,
  onDelete,
  onCancel,
  onSubmit,
}) => {
  return (
    <div className={styles.buttonsContainer}>
      {Boolean(initialValues) && typeof onDelete === 'function' ? (
        <Button
          type="danger"
          ghost
          icon="delete"
          loading={deleteConfirmLoading}
          disabled={addConfirmLoading}
          onClick={onDelete}
        >
          {texts.delete}
        </Button>
      ) : null}
      <div style={{ marginLeft: 'auto' }}>
        <Button
          onClick={onCancel}
          disabled={addConfirmLoading || deleteConfirmLoading}
        >
          {texts.cancel}
        </Button>
        <Button
          type="primary"
          loading={addConfirmLoading}
          disabled={deleteConfirmLoading}
          onClick={onSubmit}
        >
          {initialValues ? texts.edit : texts.add}
        </Button>
      </div>
    </div>
  );
};

export default ModalFooter;
